/* HAND-AUTHORED (the artifact pipeline was unavailable for this chapter) — chapter "deploy".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_DEPLOY: NodeDef = {
  "id": "deploy",
  "tagKey": "path:deploy.tag",
  "x": 40,
  "y": 980,
  "w": 220,
  "h": 116,
  "titleKey": "path:deploy.title",
  "subKey": "path:deploy.sub",
  "blocks": [
    {
      "id": "deploy.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:deploy.b1.title",
      "bodyKey": "path:deploy.b1.body",
      "flowKey": "path:deploy.b1.flow",
      "read": [
        "dora"
      ]
    },
    {
      "id": "deploy.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:deploy.b2.title",
      "film": "f-deploy"
    },
    {
      "id": "deploy.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:deploy.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:deploy.b3o.opts.0.n",
            "wKey": "path:deploy.b3o.opts.0.w",
            "uKey": "path:deploy.b3o.opts.0.u",
            "cKey": "path:deploy.b3o.opts.0.c",
            "slug": "manual-deploy"
          },
          {
            "nKey": "path:deploy.b3o.opts.1.n",
            "wKey": "path:deploy.b3o.opts.1.w",
            "uKey": "path:deploy.b3o.opts.1.u",
            "cKey": "path:deploy.b3o.opts.1.c",
            "slug": "scripted-pipeline"
          },
          {
            "nKey": "path:deploy.b3o.opts.2.n",
            "wKey": "path:deploy.b3o.opts.2.w",
            "uKey": "path:deploy.b3o.opts.2.u",
            "cKey": "path:deploy.b3o.opts.2.c",
            "slug": "central-trigger"
          },
          {
            "nKey": "path:deploy.b3o.opts.3.n",
            "wKey": "path:deploy.b3o.opts.3.w",
            "uKey": "path:deploy.b3o.opts.3.u",
            "cKey": "path:deploy.b3o.opts.3.c",
            "slug": "canary-blue-green"
          },
          {
            "nKey": "path:deploy.b3o.opts.4.n",
            "wKey": "path:deploy.b3o.opts.4.w",
            "uKey": "path:deploy.b3o.opts.4.u",
            "cKey": "path:deploy.b3o.opts.4.c",
            "slug": "gitops"
          }
        ],
        "ref": "dora"
      }
    },
    {
      "id": "deploy.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:deploy.b3.title",
      "math": {
        "exprKey": "path:deploy.b3.math.expr",
        "readKey": "path:deploy.b3.math.read",
        "useKey": "path:deploy.b3.math.use",
        "ref": "dora"
      }
    },
    {
      "id": "deploy.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:deploy.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:deploy.b4.ex.bins",
        "binCount": 2,
        "items": [
          {
            "tKey": "path:deploy.b4.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:deploy.b4.ex.items.0.why"
          },
          {
            "tKey": "path:deploy.b4.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:deploy.b4.ex.items.1.why"
          },
          {
            "tKey": "path:deploy.b4.ex.items.2.t",
            "bin": 0,
            "whyKey": "path:deploy.b4.ex.items.2.why"
          },
          {
            "tKey": "path:deploy.b4.ex.items.3.t",
            "bin": 1,
            "whyKey": "path:deploy.b4.ex.items.3.why"
          }
        ]
      }
    }
  ]
};